/* @flow weak */
import invariant from 'invariant'
import storage from 'redux-storage'
import { Iterable } from 'immutable'
import storageDebounce from 'redux-storage-decorator-debounce'
import { APP_STORAGE_LOAD } from '../app/actions'
import { fromJSON, toJSON } from '../transit'

const stateToSave = [
  ['users', 'viewer'],
]

const isReactNative =
  typeof navigator === 'object' &&
  navigator.product === 'ReactNative' // eslint-disable-line no-undef


if (isReactNative) {
  stateToSave.push(['app', 'location'])
}

const invariantFeatureState = (state, feature) => invariant(
  Iterable.isIterable(state[feature]),
  `Storage persists only immutable iterables. '${feature}' is something else.`,
)

const updateState = (state, storageStateJson) => {
  const stateJson = typeof storageStateJson === 'string' ? JSON.parse(storageStateJson) : storageStateJson
  const empty = !storageStateJson || !Object.keys(stateJson).length
  if (empty) return state
  try {
    fromJSON(storageStateJson).forEach(({ feature, featurePath, value }) => {
      const canSet = state[feature] && state[feature].hasIn(featurePath)
      if (!canSet) return
      state[feature] = state[feature].setIn(featurePath, value)
    })
  } catch (error) {
    console.log(error) // eslint-disable-line no-console
  }
  return state
}

const storageFilter = engine => ({
  ...engine,
  save(state) {
    if (!state) return Promise.resolve()

    // We don't filter by actions but by the app state structure.
    // That's fine because saving is debounced.
    let saveState
    if (isReactNative) {
      saveState = Object.keys(state).map((key) => {
        if (key === 'app') { // TODO - should save other app variables?
          return {
            feature: key,
            featurePath: ['location'],
            value: state[key].getIn(['location']),
          }
        }
        return {
          feature: key,
          featurePath: [],
          value: state[key],
        }
      })
    } else {
      saveState = stateToSave.map(([feature, ...featurePath]) => {
        invariantFeatureState(state, feature)
        return {
          feature, featurePath, value: state[feature].getIn(featurePath),
        }
      })
    }
    const json = toJSON(saveState)
    return engine.save(json)
  },
})

const createStorageMiddleware = storageEngine => {
  let decoratedEngine = storageFilter(storageEngine)
  decoratedEngine = storageDebounce(decoratedEngine, 300)
  return storage.createMiddleware(decoratedEngine)
}

export const updateStateOnStorageLoad = reducer => (state, action) => {
  if (action.type === APP_STORAGE_LOAD) {
    state = updateState(state, action.payload)
  }
  return reducer(state, action)
}

const configureStorage = (initialState, createStorageEngine) => {
  const storageEngine =
    createStorageEngine &&
    createStorageEngine(`redux-storage:${initialState.config.appName}`)
  const storageMiddleware =
    storageEngine &&
    createStorageMiddleware(storageEngine)

  return {
    STORAGE_SAVE: storage.SAVE,
    storageEngine,
    storageMiddleware,
  }
}

export default configureStorage



// WEBPACK FOOTER //
// ./src/common/configure/storage.js